import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { BookingProvider } from "@/lib/booking";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { TrustBar } from "@/components/site/TrustBar";
import { About } from "@/components/site/About";
import { FeaturedClinic } from "@/components/site/FeaturedClinic";
import { DentalServices, SkinServices } from "@/components/site/Services";
import { WhyChoose } from "@/components/site/WhyChoose";
import { Doctors } from "@/components/site/Doctors";
import { Testimonials } from "@/components/site/Testimonials";
import { Clinics } from "@/components/site/Clinics";
import { Ecosystem } from "@/components/site/Ecosystem";
import { Franchise } from "@/components/site/Franchise";
import { Faq } from "@/components/site/Faq";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { FloatingActions } from "@/components/site/FloatingActions";
import { BookingModal } from "@/components/site/BookingModal";
import ConnectLogin from "@/connect/Login";
import ResetPassword from "@/connect/ResetPassword";
import ConnectApp from "@/connect/ConnectApp";

function Site() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BookingProvider>
      <div className="App pb-16 md:pb-0">
        <Navbar />
        <main>
          <Hero />
          <TrustBar />
          <About />
          <FeaturedClinic />
          <DentalServices />
          <SkinServices />
          <WhyChoose />
          <Doctors />
          <Testimonials />
          <Clinics />
          <Ecosystem />
          <Franchise />
          <Faq />
          <Contact />
        </main>
        <Footer />
        <FloatingActions />
        <BookingModal />
      </div>
    </BookingProvider>
  );
}

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollTop />
      <Routes>
        <Route path="/" element={<Site />} />
        <Route path="/connect" element={<ConnectLogin />} />
        <Route path="/connect/reset" element={<ResetPassword />} />
        <Route path="/connect/app/*" element={<ConnectApp />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
